import {
  CREATEQUOTES,
  GETQUOTES,
  DELETEQUOTES,
  UPDATEQUOTES,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETQUOTES:
      return {
        ...state,
        quotesList: action.payload.data,
      };
    case UPDATEQUOTES:
      return {
        ...state,
        quotesUpdateStatus: action.payload.success,
      };

    case DELETEQUOTES:
      return {
        ...state,
        quotesList: state.quotesList.filter(
          (item) => item.id !== action.quoteId,
        ),
        quotesDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
